module.exports = __webpack_public_path__ + "img/Alberto-Salvatori.753cc085.jpg";